import PropTypes from 'prop-types';
import FailIcon from '../../components/icons/Fail';

const PaymentFail = ({message}) => {
  return (
    <>
      <div className="payment-status">
        <FailIcon className="payment-status-fail"/>
      </div>

      <div className="payment-status">
        <div className="payment-status-message">
          {message && message.split('\n').map((m) => (
            <div>{m}</div>
          ))}
        </div>
      </div>
    </>
  );
};

PaymentFail.propTypes = {
  message: PropTypes.string,
};

export default PaymentFail;